import { useState } from 'react';
import useInterval from './useInterval';

export type ExpiryLevel = 'none' | 'warning' | 'expired';

const MS_PER_HOUR = 60 * 60 * 1000;
const DEFAULT_CHECK_INTERVAL_MS = 60 * 1000;

interface ExpiryOptions {
  expiryHours: number;
  warningHours: number;
  checkIntervalMs?: number;
}

export interface Expiry {
  level: ExpiryLevel;
  isExpired: boolean;
  isExpiringSoon: boolean;
  expiresAt: number | null;
}

const useExpiryStatus = (startedAt: string | undefined, options: ExpiryOptions): Expiry => {
  const { expiryHours, warningHours, checkIntervalMs = DEFAULT_CHECK_INTERVAL_MS } = options;

  const [now, setNow] = useState(() => Date.now());
  useInterval(() => setNow(Date.now()), checkIntervalMs, false);

  const startedAtMs = startedAt ? new Date(startedAt).getTime() : null;
  const expiresAt = startedAtMs !== null ? startedAtMs + expiryHours * MS_PER_HOUR : null;
  const isExpired = expiresAt !== null && now >= expiresAt;
  const isExpiringSoon = startedAtMs !== null && !isExpired && now >= startedAtMs + warningHours * MS_PER_HOUR;
  const level: ExpiryLevel = isExpired ? 'expired' : isExpiringSoon ? 'warning' : 'none';

  return { level, isExpired, isExpiringSoon, expiresAt };
};

export default useExpiryStatus;
